"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDocumentClone = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M59.3 12.15H47.79V6.6a3 3 0 0 0-3-3H10.7a3 3 0 0 0-3 3v48.26a3 3 0 0 0 3 3h11.51v5.54a3 3 0 0 0 3 3H59.3a3 3 0 0 0 3-3V15.14a3 3 0 0 0-3-3zM10.7 55.29a.43.43 0 0 1-.43-.42V6.6a.43.43 0 0 1 .43-.43h34.11a.43.43 0 0 1 .42.43v48.26a.43.43 0 0 1-.42.42zm49 8.11a.43.43 0 0 1-.43.43H25.19a.43.43 0 0 1-.42-.43V58h20a3 3 0 0 0 3-3v-.9h6.13a1.28 1.28 0 0 0 0-2.56h-6.11v-6.22h6.11a1.28 1.28 0 0 0 0-2.56h-6.11v-6.4h6.11a1.28 1.28 0 0 0 0-2.56h-6.11v-6.13h1.7a1.28 1.28 0 1 0 0-2.56h-1.7v-10.4H59.3a.43.43 0 0 1 .43.42zm-46.12-47a1.28 1.28 0 0 1 1.28-1.28h20.78a1.28 1.28 0 1 1 0 2.56H14.89a1.28 1.28 0 0 1-1.28-1.28zm27.71 8.7A1.28 1.28 0 0 1 40 26.39H14.89a1.28 1.28 0 1 1 0-2.56H40a1.28 1.28 0 0 1 1.28 1.28zm0 9A1.28 1.28 0 0 1 40 35.34H14.89a1.28 1.28 0 0 1 0-2.56H40a1.28 1.28 0 0 1 1.28 1.28zm0 8.81A1.28 1.28 0 0 1 40 44.15H14.89a1.28 1.28 0 0 1 0-2.56H40a1.28 1.28 0 0 1 1.28 1.28zm0 0"
  })),
  height: undefined,
  width: undefined
});
IconDocumentClone.displayName = 'IconDocumentClone';
var _default = IconDocumentClone;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/document-clone.js
// module id = 337
// module chunks = 0